import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import {useGetDeviceOverallInfo} from "../services/device";
import Paper from "@material-ui/core/Paper";

export default function DevicesOverview() {

    const [data, setData] = useState({});
    const getDeviceOverallInfo = useGetDeviceOverallInfo();

    async function getData() {
        const deviceData = await getDeviceOverallInfo();
        setData(deviceData)
    }

    useEffect(() => {
        getData().then()
    }, []);

    const classes = useStyles();

    return (
        <Paper variant="outlined">
            <List dense className={classes.root}>
                <ListItem key="0">
                    <ListItemText id={'labelId'} primaryTypographyProps={{variant: 'body1'}}
                                  primary="تعداد دستگاه‌های ثبت شده"/>
                    <ListItemSecondaryAction>
                        <Typography variant="h6">
                            {data.deviceNum}
                        </Typography>
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider/>
                <ListItem key="1">
                    <ListItemText id={'labelId'} primaryTypographyProps={{variant: 'body1'}}
                                  primary="تعداد دستگاه‌های فعال‌شده"/>
                    <ListItemSecondaryAction>
                        <Typography variant="h6">
                            {data.activatedDeviceNum}
                        </Typography>
                    </ListItemSecondaryAction>
                </ListItem>

            </List>
        </Paper>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        backgroundColor: 'white'

    }
}));
